import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme.js";

export default {
	darkMode: "class",
	theme: {
		extend: {
			fontFamily: {
				sans: ["inter", ...defaultTheme.fontFamily.sans],
				inter: ["inter", ...defaultTheme.fontFamily.sans],
				hubot: ["hubot", ...defaultTheme.fontFamily.sans],
			},
			fontSize: {
				xs: ["0.75rem", "2"],
				sm: [".875rem", "1.5"], // small text
				base: ["1rem", "1.29"], // default text
				"menu-item": [".75rem", "1"], // menu item
				p: [".875rem", "1.5"], // p
				md: ["1.25rem", "1.2"], // btn
				"2md": ["1.375rem", "1.1"],
				lg: ["1.5rem", "1.15"], // cards heading
				"2lg": ["2rem", "1.15"], //
				xl: ["2.5rem", "1.15"], // footer claim
				"2xl": ["3rem", "1.2"], // h2
				"3xl": ["4.5rem", "1.1"], // h1
			},
			colors: {
				"zms-blue": {
					DEFAULT: "#0000FF",
					dark: "#000066",
				},
				"zms-dark-blue": {
					DEFAULT: "#00003F",
				},
				"zms-black": {
					DEFAULT: "#000000F",
				},
				"zms-optical-black": {
					DEFAULT: "#202020",
				},
				"zms-grey": {
					DEFAULT: "#F7F7F7",
					100: "#F5F5F5",
				},
				"zms-paragraph": {
					// zmenit
					DEFAULT: "#202020",
				},
				"zms-card-border": {
					DEFAULT: "#E7E7E7",
				},
			},
		},
	},
} satisfies Partial<Config>;
